import React from 'react';

function UnauthorizedView({ children }) {
  return (
    <div className="mx-4 mt-12 shadow-lg p-2  border border-1 rounded-lg">
      {children}
    </div>
  );
}

export default UnauthorizedView;
